export function keepFilePathChars(s: string) {
  return s
    .replace(/[^a-z\-_0-9а-яё./]/gi, '')
    .replace(/\.{2,}/g, '.')
    .replace(/\/+/g, '/');
}

export function keepFileNameChars(s: string) {
  return keepFilePathChars(s).split('/')[0];
}

export function capitalize(s: string) {
  if (!s) return s;
  return s[0].toUpperCase() + s.slice(1);
}

export function ensureEndsWithDot(s: string) {
  s = s.trim();
  if (!s) return s;
  if (s.endsWith('.') || s.endsWith('?') || s.endsWith(')')) return s;
  return `${s}.`;
}
